import { Directive, TemplateRef } from '@angular/core';

@Directive({
	selector: 'ng-template[aeToggleButtonOff]',
})
export class ToggleButtonOffDirective {
	constructor(public template: TemplateRef<any>) {}
}
